<template>
  <div class="about-frame">
    <Content :routeArr="routeArr" />

    <div class="box" v-if="!isMobile">
      <div class="left">
        <div
          :class="['sub-item', activeCode == item.code ? 'current' : '']"
          v-for="item in $store.state.subList"
          :key="item.id"
          @click="changeSubNav(item)"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="right">
        <!-- 直接访问的渲染方式 -->
        <div
          class="new"
          v-if="newsList.length != 0 && clickConfig == 0 && moduleFlag == 1"
        >
          <div class="right-top">
            <p class="top-title">{{ moduleTitle }}</p>
            <p class="top-sub">- {{ moduleDesc }} -</p>
          </div>

          <div class="content" v-html="newsList[0].contentStr"></div>
        </div>

        <!-- 列表访问的渲染方式 -->
        <div class="list" v-if="newsList.length != 0 && clickConfig == 1">
          <div class="right-top">
            <p class="top-title">{{ moduleTitle }}</p>
            <p class="top-sub">- {{ moduleDesc }} -</p>
          </div>

          <ul class="new-list">
            <li class="item" v-for="item in newsList" :key="item.id">
              <div class="avatar">
                <img :src="URL + item.newsImageUrl" alt="" />
              </div>
              <div class="info">
                <div class="info-name">{{ item.title }}</div>
                <div class="info-desc">{{ item.description }}</div>
                <div class="info-str" v-html="item.contentStr"></div>
              </div>
            </li>
          </ul>
        </div>

        <!-- 定制访问的渲染方式 -->
        <div class="module" v-if="moduleFlag == 0">
          <History v-if="tabName == '发展历程'" />
          <Honor v-if="tabName == '荣誉资质'" />
        </div>
      </div>
    </div>

    <div class="m-box" v-if="isMobile == 1">
      <van-tabs
        v-model="activeCode"
        @change="toChange"
        title-active-color="#e62129"
      >
        <van-tab
          v-for="item in $store.state.subList"
          :key="item.id"
          :name="item.code"
          :title="item.name"
          @click="changeSubNav(item)"
        >
          <div class="right">
            <!-- 直接访问的渲染方式 -->
            <div
              class="new"
              v-if="newsList.length != 0 && clickConfig == 0 && moduleFlag == 1"
            >
              <div class="right-top">
                <p class="top-title">{{ moduleTitle }}</p>
                <p class="top-sub">- {{ moduleDesc }} -</p>
              </div>

              <div class="content" v-html="newsList[0].contentStr"></div>
            </div>

            <!-- 列表访问的渲染方式 -->
            <div class="list" v-if="newsList.length != 0 && clickConfig == 1">
              <div class="right-top">
                <p class="top-title">{{ moduleTitle }}</p>
                <p class="top-sub">- {{ moduleDesc }} -</p>
              </div>

              <ul class="new-list">
                <li class="item" v-for="item in newsList" :key="item.id">
                  <div class="avatar">
                    <img :src="URL + item.newsImageUrl" alt="" />
                  </div>
                  <div class="info">
                    <div class="info-name">{{ item.title }}</div>
                    <div class="info-desc">{{ item.description }}</div>
                    <div class="info-str" v-html="item.contentStr"></div>
                  </div>
                </li>
              </ul>
            </div>

            <!-- 定制访问的渲染方式 -->
            <div class="module" v-if="moduleFlag == 0">
              <History v-if="tabName == '发展历程'" />
              <Honor v-if="tabName == '荣誉资质'" />
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import Content from "@/components/content.vue";
import History from "@/components/history.vue";
import Honor from "@/components/honor.vue";

import { sysNewsList } from "../../util/news/news.js";
import { URL } from "../../util/config";
export default {
  data() {
    return {
      URL,
      activeCode: "",
      params: {
        pageIndex: 1,
        pageSize: 10,
        newsCode: "",
        typeCode: "",
      },
      isMobile: sessionStorage.getItem("isMobile"),
      routeArr: [],
      newsList: [],
      moduleTitle: "",
      moduleDesc: "", // 模版渲染的标题以及英文翻译
      tabName: "",
      moduleFlag: 1,
      clickConfig: 0,
    };
  },
  components: {
    Content,
    History,
    Honor,
  },
  created() {},
  mounted() {
    const code = sessionStorage.getItem("childCode");
    if (code) {
      this.$store.state.subList.forEach((ele) => {
        if (ele.code == code) {
          this.changeSubNav(ele);
        }
      });
    } else {
      this.changeSubNav(this.$store.state.subList[0]);
    }
    this.routeArr = [
      { name: "首页", path: "/" },
      { name: this.$store.state.name, path: "/about" },
    ];
  },
  methods: {
    toChange(name) {
      const trueArr = this.$store.state.subList.filter(
        (ele) => ele.code == name
      );
      this.changeSubNav(trueArr[0]);
    },
    // 二级导航切换
    changeSubNav(item) {
      // console.log(JSON.parse(JSON.stringify(item)));
      this.activeCode = item.code;
      this.tabName = item.name;
      this.clickConfig = item.clickConfig;
      this.moduleFlag = item.moduleFlag;
      this.moduleTitle = item.name;
      this.moduleDesc = item.contextStrs;

      this.params.newsCode = item.code;
      sessionStorage.setItem("childCode", item.code);

      if (this.moduleFlag == 1) {
        this.getList();
      }
    },
    getList() {
      //获取列表
      sysNewsList(this.params).then((res) => {
        if (res.code === 0) {
          this.newsList = res.data.list;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@function pxToRem($args) {
  @return $args / 50 + rem;
}

.about-frame {
  .box {
    width: 1200px;
    margin: 60px auto;
    display: flex;

    .left {
      width: 250px;
      flex-shrink: 0;
      text-align: center;

      .sub-item {
        width: 181px;
        height: auto;
        border-left: 5px #fff solid;
        margin-top: 30px;
        color: #666666;
        font-size: 22px;
        display: block;
        line-height: 22px;
        text-align: center;

        &:hover {
          cursor: pointer;
          color: $theme;
        }
      }
      .current {
        color: $theme;
        border-color: $theme;
      }
    }
  }
  .right {
    flex-grow: 1;

    .right-top {
      height: 110px;
      text-align: center;

      .top-title {
        margin-top: 10px;
        font-size: 36px;
      }
      .top-sub {
        color: #999999;
        margin-top: 10px;
      }
    }
    .content {
      width: 900px;
      margin: 10px 0;
    }

    .new-list {
      width: 100%;

      .item {
        padding: 20px 0;
        display: flex;
        justify-content: space-between;

        .avatar {
          img {
            width: 225px;
            height: 300px;
            display: block;
          }
        }
        .info {
          width: 700px;

          .info-name {
            font-size: 22px;
            color: $theme;
            margin-top: 15px;
          }
          .info-desc {
            color: #666666;
            margin-top: 40px;
          }
          .info-str {
            line-height: 30px;
            font-size: 14px;
            margin-top: 40px;
          }
        }
      }
    }
  }
}
@media (max-width: 1300px) {
  .about-frame {
    .box {
      width: 1000px;

      .left {
        width: 150px;

        .sub-item {
          width: calc(100% - 5px);
        }
      }
      .right .new-list .item .info {
        width: 600px;
      }
    }
  }
}
@media (max-width: 1024px) {
  .about-frame .right {
    margin-bottom: pxToRem(30);
    .right-top {
      height: fit-content;
      margin-bottom: pxToRem(30);
      .top-title {
        color: $theme;
        font-size: pxToRem(20);
        font-weight: bold;
      }
      .top-sub {
        font-size: pxToRem(14);
      }
    }
    .content {
      width: 100%;
      padding: 0 pxToRem(15);
      box-sizing: border-box;
      text-align: justify;
    }
    .new-list {
      padding: 0 pxToRem(20);
      box-sizing: border-box;

      .item {
        border-bottom: 1px solid #d5d5d5;
        .avatar {
          img {
            width: pxToRem(100);
            height: pxToRem(135);
          }
        }
        .info {
          padding-left: pxToRem(20);

          .info-name {
            margin-top: 0;
            font-size: pxToRem(16);
          }
          .info-desc {
            margin-top: pxToRem(10);
            font-size: pxToRem(15);
          }
          .info-str {
            margin-top: pxToRem(20);
            font-size: pxToRem(13);
          }
        }
      }
    }
  }
}
</style>
